import { API_URL } from "settings";
import { toast } from "react-toastify";
import l from "components/util/l";

const downloadFile = (url, blob = null, name = '') => {

  if (!blob && !url) throw new Error("Either url or blob must be provided");

  getBlob(url, blob, (finalBlob) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(finalBlob);
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  });

}

const getBlob = (url, blob, callback) => {
  if (blob) callback(blob);
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = () => {
    const blob = xhr.response;
    callback(blob);
  };
  xhr.send();
}

const uploadFile = ({ callback, flowId, multiple = false, accept = '*' }) => {

  const input = document.createElement("input");
  input.multiple = multiple;
  input.type = "file";
  input.style.display = "none";
  input.accept = accept;

  input.onchange = async (e) => {
    const files = e.target.files;
    if (files.length === 0) return;
    callback(await uploadFiles(files, flowId));
  }

  document.body.appendChild(input);
  input.click();

}

// Uploads files the user never picked through a dialog — pasted from the clipboard,
// dropped on a view, produced by a canvas. Returns the stored file objects, skipping
// (and reporting) the ones that failed, so one bad file does not lose the rest.
const uploadFiles = async (files, flowId) => {

  const results = [];

  for (const file of files) {

    try {

      const res = await callUploadFile(file, flowId);

      if (res.ok)
        results.push(res.body);
      else
        toast.error(l("Ha ocurrido un error al subir el archivo {file_name}%GA090", { file_name: file.name }));

    } catch (error) {
      toast.error(l("Ha ocurrido un error al subir el archivo {file_name}%GA090", { file_name: file.name }));
    }

  }

  return results;

}

// A screen that belongs to a flow names it, and the api stores the file under that flow;
// one that does not (settings, the project import) leaves it to the uploader.
const callUploadFile = async (file, flowId) => {

  let url = `${API_URL}/files/`;
  let formData = new FormData();
  formData.append("file", file);
  if (flowId) formData.append("flow_id", flowId);

  let res = await fetch(url, {
    cache: "no-cache",
    method: "POST",
    headers: {
      "Authorization": `Token ${sessionStorage.getItem("token")}`
    },
    body: formData
  });

  let json = await res.json();
  return {
    body: json,
    ok: res.status === 200 || res.status === 201
  }

}

export { downloadFile, uploadFile, uploadFiles }